import { Trans } from '@lingui/react/macro';
import { useAtomValue } from 'jotai';

import { PatientNamePrivacy } from '../../../../common-components/composed/PatientNamePrivacy';
import { capitalize } from '../../../../utils/string';
import { selectedPlanAtom } from '../../atoms';

export const PatientInformationSection = () => {
  const currentPlan = useAtomValue(selectedPlanAtom);

  return (
    <div className="vai-space-y-6">
      {/* Patient Details in single row */}
      <div className="vai-grid vai-grid-cols-4 vai-gap-8">
        {/* Patient Name */}
        <div>
          <div className="vai-text-sm vai-font-normal vai-text-muted-foreground vai-leading-none">
            <Trans>Patient Name</Trans>
          </div>
          <div className="vai-mt-3 vai-text-sm vai-font-normal vai-text-foreground">
            <PatientNamePrivacy
              name={currentPlan?.patient?.displayName || 'N/A'}
            />
          </div>
        </div>

        {/* Member ID */}
        <div>
          <div className="vai-text-sm vai-font-normal vai-text-muted-foreground vai-leading-none">
            <Trans>Member ID</Trans>
          </div>
          <div className="vai-mt-3 vai-text-sm vai-font-normal vai-text-foreground">
            {currentPlan?.patient?.memberId || 'N/A'}
          </div>
        </div>

        {/* Group ID */}
        <div>
          <div className="vai-text-sm vai-font-normal vai-text-muted-foreground vai-leading-none">
            <Trans>Group ID</Trans>
          </div>
          <div className="vai-mt-3 vai-text-sm vai-font-normal vai-text-foreground">
            {currentPlan?.plan?.groupNumber || 'N/A'}
          </div>
        </div>

        {/* Subscriber */}
        <div>
          <div className="vai-text-sm vai-font-normal vai-text-muted-foreground vai-leading-none">
            <Trans>Subscriber</Trans>
          </div>
          <div className="vai-mt-3 vai-text-sm vai-font-normal vai-text-foreground">
            <PatientNamePrivacy
              name={
                currentPlan?.subscriber?.firstName &&
                currentPlan?.subscriber?.lastName
                  ? `${capitalize(
                      currentPlan.subscriber.firstName.toLowerCase(),
                    )} ${capitalize(
                      currentPlan.subscriber.lastName.toLowerCase(),
                    )}`
                  : 'N/A'
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
